import { HOST } from "../constants/HostConstants";

export const commentApproveBulk = async (report_ids) => {
  try {
    const res = await fetch(`${HOST}/api/comment/commentApproveBulk`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ report_ids }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
return { success: false, error: err.message };
  }
};
